/**
 * Weclapp Newsletter Integration
 * Handles newsletter signup for Weclapp forms
 */

function signNewsletter() {
  // Try to find form fields (works for both mobile and desktop versions)
  let firstName = document.querySelector('#idWC_firstname') || document.querySelector('#idWC_firstname_desktop');
  let lastName = document.querySelector('#idWC_lastName') || document.querySelector('#idWC_lastName_desktop');
  let mail = document.querySelector('#idWC_email') || document.querySelector('#idWC_email_desktop');
  let checkbox = document.querySelector('input[name="agree_newsletter"]');

  // Check if elements exist before accessing their values
  if (firstName && lastName && mail && checkbox) {
    let firstNameValue = firstName.value;
    let lastNameValue = lastName.value;
    let mailValue = mail.value;
    let checkboxChecked = checkbox.checked;

    if (mailValue !== '' && firstNameValue !== '' && lastNameValue !== '' && checkboxChecked === true) {
      console.log('start fetch');
      fetch('https://setnewsletter-74u7fcv2wa-uc.a.run.app', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          firstName: firstNameValue,
          lastName: lastNameValue,
          mail: mailValue,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            console.log('Error');
          }
          return true;
        })
        .then((data) => {
          // nothing
        })
        .catch((error) => {
          console.log('Error', error);
        });
    }

    if (mailValue === '' && firstNameValue === '' && lastNameValue === '') {
      alert('Trage eine Email, einen Namen und Nachnamen ein.');
      return false;
    }
  }

  return true;
} 